import axios from 'axios';
import { fetchConfigError, fetchConfigPending, fetchConfigSuccess } from './config';
import authorizeRequest from '../helpers/authorize-request';
import BASE_URL from '../helpers/base-url';

const URL = `${BASE_URL}/api/config`;

function fetchConfig() {
  return async (dispatch) => {
    dispatch(fetchConfigPending);

    axios.get(URL, authorizeRequest())
      .then(response => {
        dispatch(fetchConfigSuccess(response.data));
      })
      .catch(() => {
        dispatch(fetchConfigError);
      });
  }
}

export default fetchConfig;


// WEBPACK FOOTER //
// ./src/actions/fetchConfig.js